const l = {
  name: "Code1",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 3H11V5H2V3Z" fill="currentColor"/>
<path d="M13 11H22V13H13V11Z" fill="currentColor"/>
<path d="M22 7H6V9H22V7Z" fill="currentColor"/>
<path d="M17 3H22V5H17V3Z" fill="currentColor"/>
<path d="M7 11H2V13H7V11Z" fill="currentColor"/>
<path d="M2 19H11V21H2V19Z" fill="currentColor"/>
<path d="M22 19H17V21H22V19Z" fill="currentColor"/>
<path d="M14 21C14.5523 21 15 20.5523 15 20C15 19.4477 14.5523 19 14 19C13.4477 19 13 19.4477 13 20C13 20.5523 13.4477 21 14 21Z" fill="currentColor"/>
<path d="M11 12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11C10.5523 11 11 11.4477 11 12Z" fill="currentColor"/>
<path d="M3 9C3.55228 9 4 8.55228 4 8C4 7.44772 3.55228 7 3 7C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9Z" fill="currentColor"/>
<path d="M15 4C15 4.55228 14.5523 5 14 5C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3C14.5523 3 15 3.44772 15 4Z" fill="currentColor"/>
<path d="M2 15H18V17H2V15Z" fill="currentColor"/>
<path d="M22 16C22 16.5523 21.5523 17 21 17C20.4477 17 20 16.5523 20 16C20 15.4477 20.4477 15 21 15C21.5523 15 22 15.4477 22 16Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as Code1
};
